import { render, staticRenderFns } from "./FacebookEdit.vue?vue&type=template&id=66d3ade8&scoped=true&"
import script from "./FacebookEdit.vue?vue&type=script&lang=ts&"
export * from "./FacebookEdit.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookEdit.vue?vue&type=style&index=0&id=66d3ade8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3ade8",
  null
  
)

export default component.exports